export { default } from './SkeletonInteractiveMap';
